import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Home.css";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
// Import images
import slide1 from "../assets/images/slider/Using/banner_11.png";
import slide2 from "../assets/images/slider/Using/banner_22.png";
import video_img from "../assets/images/slider/Using/banner_video.PNG";
import aboutImg from "../assets/images/aboutusimg.PNG";
import box1 from "../assets/images/Categories/Both-side-grey.jpeg";
import box2 from "../assets/images/Categories/Maplitho.avif";
import Sweet from "../assets/images/Categories/PE-Coated.jpeg";
import LWC from "../assets/images/Categories/Top-lwc.jpeg";
import box3 from "../assets/images/kappa-paper-board-500x500.jpg";
import Hi_Tech_Top_Black from "../assets/images/Hi_Tech_Top_Black.png";
import box4 from "../assets/images/Categories/Supreme-grey.jpeg";
import box5 from "../assets/images/product-jpeg-500x500.jpg";
import { useState } from "react";
import { AiOutlinePlayCircle } from "react-icons/ai";
import { FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

const productCategories = [
  {
    title: "Hi Tech Board (Both Side Grey)",
    image: box1,
    products: ["All Types of Boxes", "Jewellery Boxes", "Rigid Boxes"],
  },
  {
    title: "Hi Tech Top Maplitho (A Grade)",
    image: box2,
    products: ["Table Calendar", "Box Files", "Mobile Boxes"],
  },
  {
    title: "Hi Tech Top Black (A Grade)",
    image: Hi_Tech_Top_Black,
    products: ["Wallet Box", "Export Files", "Arabic Country Notebooks"],
  },
  {
    title: "Hi Tech Supreme Grey (Brown / Brown)",
    image: box4,
    products: ["Calendar Boxes",
      "Diaries",
    ],
  },
  {
    title: "Hi Tech Top PE Coated",
    image: Sweet,
    products: ["Sweet Boxes", "Bakery Items", "Oil Content Packing"],
  },
  {
    title: "Hi Tech TOP LWC",
    image: LWC,
    products: ["Premium Packaging Solutions"],
  },
  {
    title: "Hi Tech Both Side White",
    image: box3,
    products: [
      "Jewellery Boxes",
      "Bazzles",
    ],
  },
];

const CounterItem = ({ icon, end, suffix, title }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div className="col-lg-3 col-md-6 counter-column" ref={ref}>
      <div className="d-flex align-items-center justify-content-center gap-3 py-5">
        <div className="counter-icon">
          <i className={`bi ${icon}`}></i>
        </div>
        <div className="counter-content text-start">
          <h2 className="counter-number m-0">
            {inView ? (
              <CountUp end={end} duration={2.5} separator="," suffix={suffix} />
            ) : (
              "0"
            )}
          </h2>
          <p className="counter-title m-0 text-white">{title}</p>
        </div>
      </div>
    </div>
  );
};

const HomePage = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);
  return (
    <div style={{ marginTop: "70px" }}>
      {/* Hero Slider */}
      <section className="hero-slider hero-style-1">
        <div
          className="carousel slide"
          id="heroCarousel"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {[slide1, slide2].map((slide, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <div
                  className="d-block w-100 hero-slide"
                  style={{
                    backgroundImage: `url(${slide})`,
                  }}
                ></div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </section>

      {/* Experience Section - Professional & Attractive (Image on Right) */}
      <section className="experience-section py-3">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left Content */}
            <div className="col-lg-6">
              <div className="experience-content">
                <div className="welcome-intro mb-2">
                  <span className="welcome-badge">Welcome to</span>
                  <div className="title-divider mb-2"></div>
                  <h1 className="company-name">
                    <span className="company-primary">SRI KRISHNA</span>{" "}
                    <span className="company-secondary">HI-TECH PAPER BOARD</span>
                  </h1>
                </div>

                <div className="experience-statement">
                  <h2 className="experience-title">
                    9+ Years of Excellence in Paper Industry
                  </h2>
                  <p className="experience-description mt-3">
                    Delivering high-quality Kappa board solutions with consistent innovation, durability, and customer satisfaction.
                  </p>
                </div>

                <div className="features-box p-4 rounded ">
                  <h5 className="features-title mb-2">Our Core Expertise</h5>
                  <div className="features-grid">
                    {[
                      "Premium & high Kappa Board Manufacturing",
                      "Advanced Cutting & Finishing",
                      "Eco-Friendly Production",
                      "Reliable Supply Chain"
                    ].map((feature, index) => (
                      <div key={index} className="feature-item">
                        <div className="feature-icon">
                          <i className="bi bi-check-circle"></i>
                        </div>
                        <span className="feature-text">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-lg-6">
              <div className="about-image-container">
                <div className="image-wrapper">
                  <img 
                    src={aboutImg} 
                    alt="Sri Krishna Hi-Tech Paper Board Manufacturing" 
                    className="img-fluid rounded floating-image" 
                  />
                  <div className="image-overlay"></div>
                </div>
                <div className="experience-badge floating-badge">
                  <span className="years">9+</span>
                  <span className="text">Years of Experience</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Board Specification & Production Capacity Section */}
      <section className="specification-section py-3 ">
        <div className="container">
          <div className="row g-4">
            {/* Board Specification */}
            <div className="col-lg-6">
              <div className="spec-card h-100">
                <div className="spec-header">
                  <h3 className="features-title">Board Specification</h3>
                </div>
                <div className="spec-content">
                  <div className="spec-grid">
                    {[
                      { name: "Strength", icon: "bi-shield-check" },
                      { name: "Stiffness", icon: "bi-arrow-up-circle" },
                      { name: "Surface", icon: "bi-grid-3x3-gap-fill" },
                      { name: "Smooth and Customised size", icon: "bi-bounding-box-circles" }
                    ].map((item, index) => (
                      <div key={index} className="spec-item">
                        <div className="spec-icon-wrapper">
                          <i className={`bi ${item.icon}`}></i>
                        </div>
                        <span className="spec-text">{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Production Capacity */}
            <div className="col-lg-6">
              <div className="spec-card h-100">
                <div className="spec-header">
                  <h3 className="features-title">Production Capacity</h3>
                </div>
                <div className="spec-content">
                  <div className="capacity-grid">
                    {[
                      { name: "60 - 70 Tons Per Day", icon: "bi-trophy" },
                      { name: "A legacy of 25 years in high-quality paperboard production", icon: "bi-award" }
                    ].map((item, index) => (
                      <div key={index} className="spec-item">
                        <div className="spec-icon-wrapper">
                          <i className={`bi ${item.icon}`}></i>
                        </div>
                        <span className="spec-text">{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Tour Section */}
      {/* Video Tour Section */}
<section className="video-tour-section position-relative overflow-hidden d-flex align-items-center justify-content-center">
  {/* Background Image with Overlay */}
  <div className="position-absolute top-0 start-0 w-100 h-100">
    <div 
      className="position-absolute top-0 start-0 w-100 h-100 bg-cover bg-center"
      style={{
        backgroundImage: `url(${video_img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        transition: 'transform 0.7s ease'
      }}
      id="video-bg"
    >
      {/* Gradient Overlay */}
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-to-right"></div>
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-to-top"></div>
      
      {/* Animated Particles */}
      <div className="position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
        <div className="particles-light particles-1"></div>
        <div className="particles-light particles-2"></div>
      </div>
    </div>
    
    {/* Particles */}
    <div className="position-absolute top-0 start-0 w-100 h-100 particles-container">
      {[...Array(12)].map((_, i) => (
        <div key={i} className={`particle particle-${i}`}></div>
      ))}
    </div>
    
    {/* Sparkle Effects */}
    <div className="position-absolute top-0 start-0 w-100 h-100 sparkle-container">
      {[...Array(8)].map((_, i) => (
        <div key={`sparkle-${i}`} className={`sparkle sparkle-${i}`}></div>
      ))}
    </div>
  </div>

  {/* Content */}
  <div className="position-relative z-10 text-center px-3 px-md-4">
    <div className="animate-fade-up">
      {/* Main Title */}
      <h2 className="text-white mb-3 mb-md-4 video-title">
        Hi-Tech Board <span className="text-accent">Virtual Tour</span>
      </h2>
      
      {/* Subtitle */}
      <p className="text-white opacity-90 mb-4 mb-md-5 video-subtitle mx-auto">
        Experience our facilities in 360°
      </p>

      {/* Play Button */}
      <div className="d-flex justify-content-center">
        <button
          onMouseEnter={() => document.getElementById('video-bg').style.transform = 'scale(1.05)'}
          onMouseLeave={() => document.getElementById('video-bg').style.transform = 'scale(1)'}
          onClick={() => setShowVideoModal(true)}
          className="play-button-wrapper"
        >
          {/* Outer glow ring */}
          <div className="play-button-glow"></div>
          
          {/* Middle ring */}
          <div className="play-button-ring"></div>
          
          {/* Play button */}
          <div className="play-button position-relative">
            {/* Inner shine effect */}
            <div className="play-button-shine"></div>

            {/* Play icon */}
            <div className="play-icon">
              <AiOutlinePlayCircle className="play-icon-svg" />
            </div>

            {/* Outer pulse rings */}
            <div className="pulse-ring pulse-ring-1"></div>
            <div className="pulse-ring pulse-ring-2"></div>
          </div>

          {/* Radial burst effect */}
          <div className="radial-burst"></div>
        </button>
      </div>
    </div>
  </div>

  {/* Simple Modal Popup */}
  {showVideoModal && (
    <div className="simple-modal-overlay" onClick={() => setShowVideoModal(false)}>
      <div className="simple-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="simple-modal-header">
          <h3 className="simple-modal-title">Factory Virtual Tour</h3>
          <button 
            className="simple-modal-close"
            onClick={() => setShowVideoModal(false)}
          >
            ×
          </button>
        </div>
        <div className="simple-modal-body">
          <iframe 
            width="100%" 
            height="400" 
            src="https://www.youtube.com/embed/7WbcgEhoUBE?si=LkLd-KTHWdbkRb9x&autoplay=1" 
            title="YouTube video player" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  )}
</section>

      {/* Product Categories */}
      <section className="py-5 category-section">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Our Product Categories</h2>
            <p className="text-muted">
              Advanced packaging boards designed for premium applications
            </p>
          </div>

          <div className="row g-4">
            {productCategories.map((cat, index) => (
              <div className="col-lg-4 col-md-6" key={index}>
                <div className="category-card">
                  <div
                    className="category-image"
                    style={{ backgroundImage: `url(${cat.image})` }}
                  >
                    <div className="overlay"></div>
                    <h5 className="category-title">{cat.title}</h5>
                  </div>

                  <div className="category-content fw-semibold">
                    <ul className="list-none p-0 m-0">
                      {cat.products.map((item, i) => (
                        <li
                          key={i}
                          className="feature-text flex items-start gap-2"
                        >
                          <i className="bi bi-check-circle feature-icon me-2"></i>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>

                    <Link to="/products" className="btn btn-view-products btn-sm mt-2">
                      View Products →
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Statistics Counter Section */}
      <section className="counter-wrapper container-fluid p-0">
        <div className="row g-0">
          <CounterItem
            icon="bi-person-badge"
            end={100}
            suffix="+"
            title="Employees"
          />
          <CounterItem
            icon="bi bi-buildings"
            end={20}
            suffix="+"
            title="Acres"
          />
          <CounterItem icon="bi-trophy" end={35} suffix="+" title="Product Variations" />
          <CounterItem
            icon="bi-hand-thumbs-up"
            end={100}
            suffix="%"
            title="Satisfied customers"
          />
        </div>
      </section>

      {/* Get in Touch Section */}
      <section className="contact-section">
        <div className="contact-container container">
          <div className="contact-text">
            <h2>Let's Get in Touch!</h2>
            <p>
              Raising a heavy fur muff that covered the whole of her lower arm
              towards the viewer. Gregor then turned to look out the window at
              the dull weather.
            </p>
          </div>

          <div className="contact-methods">
            <div className="contact-item">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <div>
                <h3>Call us</h3>
                <p>+91 97871 82226</p>
              </div>
            </div>

            <div className="contact-item">
              <div className="icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div>
                <h3>Email us</h3>
                <p>srikrishnahitechpaperboard@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;